(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amai-pdp-simple-v1"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('amai-skin-explorer')) {
  customElements.define('amai-skin-explorer', class extends HTMLElement {
    connectedCallback() {
      if (this.skinController) return;
      this.skinController = new AbortController();
      const init = () => {
        if (!this.isConnected || this.hasAttribute('data-enhanced')) return;
        if (!this.querySelector('[data-skin-panel]')) return;
        this.setAttribute('data-enhanced', '');
        this.selectSkin('barrier');
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-skin-select]');
          if (button && button.closest('amai-skin-explorer') === this) {
            this.selectSkin(button.dataset.skinSelect);
          }
        }, { signal: this.skinController.signal });
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true, signal: this.skinController.signal });
      } else {
        init();
      }
    }
    selectSkin(key) {
      if (!this.querySelector('[data-skin-panel="' + key + '"]')) return;
      this.dataset.active = key;
      this.querySelectorAll('[data-skin-select]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.skinSelect === key));
      });
      this.querySelectorAll('[data-skin-panel]').forEach(panel => {
        panel.hidden = panel.dataset.skinPanel !== key;
      });
    }
    disconnectedCallback() {
      this.skinController?.abort();
      this.skinController = null;
      this.removeAttribute('data-enhanced');
      this.querySelectorAll('[data-skin-panel]').forEach(panel => { panel.hidden = false; });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amai-reviews"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionId = "{{ section.id }}";
  var root = document.querySelector('[data-section-id="' + sectionId + '"].amai-rv');
  if (!root) return;

  // ============ FILTERS ============
  var filters = root.querySelectorAll('.amai-rv__filter');
  var cards = root.querySelectorAll('.amai-rv__card');

  filters.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var target = btn.getAttribute('data-filter');
      filters.forEach(function(f) { f.classList.remove('is-active'); });
      btn.classList.add('is-active');

      cards.forEach(function(card) {
        if (target === 'all') {
          card.classList.remove('is-hidden');
          return;
        }
        var tag = card.getAttribute('data-tag') || '';
        if (tag.indexOf(target) !== -1) card.classList.remove('is-hidden');
        else card.classList.add('is-hidden');
      });
    });
  });

  // ============ LOAD MORE (esconde tras los primeros 6) ============
  var moreBtn = document.getElementById('amai-rv-more-' + sectionId);
  if (moreBtn && cards.length > 6) {
    cards.forEach(function(card, i) {
      if (i >= 6) card.classList.add('is-hidden');
    });
    var expanded = false;
    moreBtn.addEventListener('click', function() {
      if (!expanded) {
        cards.forEach(function(card) { card.classList.remove('is-hidden'); });
        moreBtn.textContent = 'Ver menos';
        expanded = true;
      } else {
        cards.forEach(function(card, i) {
          if (i >= 6) card.classList.add('is-hidden');
          else card.classList.remove('is-hidden');
        });
        moreBtn.textContent = 'Ver más reseñas';
        expanded = false;
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pack-selector-rutinas"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionId = "{{ section.id }}";
  var form = document.getElementById('amai-pack-form-' + sectionId);
  if (!form) return;

  var priceLabel = document.getElementById('amai-pack-cta-price-' + sectionId);
  var radios = form.querySelectorAll('.amai-pack__radio');

  function updatePriceLabel() {
    var checked = form.querySelector('.amai-pack__radio:checked');
    if (!checked || !priceLabel) return;
    var label = checked.closest('.amai-pack__option');
    var price = label.getAttribute('data-price') || '';
    priceLabel.textContent = price;
  }

  radios.forEach(function(r) {
    r.addEventListener('change', updatePriceLabel);
  });

  updatePriceLabel();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rutina-am-pm"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionId = "{{ section.id }}";
  var root = document.querySelector('[data-section-id="' + sectionId + '"].amai-rutina');
  if (!root) return;

  var tabs = root.querySelectorAll('.amai-rutina__tab');
  var panels = root.querySelectorAll('.amai-rutina__panel');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var target = tab.getAttribute('data-tab');

      tabs.forEach(function(t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');

      panels.forEach(function(p) {
        if (p.getAttribute('data-panel') === target) {
          p.removeAttribute('hidden');
          p.classList.add('is-active');
        } else {
          p.setAttribute('hidden', '');
          p.classList.remove('is-active');
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionId = "{{ section.id }}";
  var track = document.getElementById('amai-trust-track-' + sectionId);
  if (!track) return;

  var items = track.querySelectorAll('.amai-trust__item');
  if (items.length === 0) return;

  // Solo rotamos en mobile
  var isMobile = window.matchMedia('(max-width: 749px)').matches;
  if (!isMobile) return;

  var current = 0;
  items[0].classList.add('is-active');

  setInterval(function() {
    items[current].classList.remove('is-active');
    current = (current + 1) % items.length;
    items[current].classList.add('is-active');
  }, 2800);
})();

  } catch(e) { console.error(e); }
})();
})();
